import { FC } from "react";
import ServicePage from "./ServicePage";

const MultiRoleServicePage: FC = () => (
  <ServicePage
    title="Multi Rol Güvenlik Görevlisi"
    seoDescription="Temel itfaiyecilik eğitimi almış Securitas Özel Güvenlik Görevlileri, Multi Rol Güvenlik Görevlisi (MRGG) olarak riskli çalışma alanlarında yangınlara ilk müdahaleyi destekler."
    intro={[
      <>
        Bilgi lideri Securitas, riskli çalışma ve üretim alanlarında ortaya
        çıkabilecek yangınlara ilk müdahale ihtiyacına etkin çözümler sunar. Bu
        kapsamda, itfaiyecilik eğitimi alan Securitas Özel Güvenlik Görevlileri, ek
        yetkinlikler kazanarak <b>Multi Rol Güvenlik Görevlisi (MRGG)</b> olarak
        görev yapar.
      </>,
      'Multi Rol Güvenlik Görevlileri (MRGG), projelerin fiziksel koşullarına hızla uyum sağlayabilecek niteliklere göre özenle seçilir. Multi Rol Güvenlik Görevlisi adayı olarak seçilen Özel Güvenlik Görevlileri Temel İtfaiye eğitimlerini başarıyla tamamlayarak, gerektiğinde tüm becerilere ve ekipmanlara sahip bir "Multi-Rol" itfaiye görevlisine dönüşür.',
    ]}
    sections={[
      {
        icon: "grad",
        title: "Eğitim",
        paragraphs: [
          "Tesiste yapılacak yangın risk değerlendirmesi sonucunda, multi rol güvenlik görevlilerine temel itfaiyecilik eğitimi, ilk yardım eğitimi ve tesis içi eğitimler verilir. Bu eğitimler, belirlenen yangın risk oranına göre belirli aralıklarla tekrarlanır.",
        ],
      },
      {
        icon: "tool",
        title: "Teçhizat ve Donanım",
        paragraphs: [
          "Multi Rol ekipleri, görevleri gereği kullandıkları araç, gereç ve ekipmanların yanı sıra kişisel koruyucu donanımlarını da tesis prosesine uygun şekilde temin eder ve düzenli olarak kontrolden geçirir.",
        ],
      },
    ]}
    image={{
      src: "/uploads/site/hero-multirol.jpg",
      alt: "Multi Rol Güvenlik Görevlisi yangın söndürücüyle müdahale ediyor",
    }}
  />
);

export default MultiRoleServicePage;
